import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { GtStripeService } from '../../services/gt-stripe.service';
import { SessionService } from '../../services/session.service';

@Component({
    selector: 'stripe-add-terminal-reader-modal',
    templateUrl: './stripe-add-terminal-reader-modal.component.html',
    styleUrl: './stripe-add-terminal-reader-modal.component.scss',
    standalone: false
})
export class StripeAddTerminalReaderModalComponent extends BaseModalComponent {
  public locationId: string;
  public form = new FormGroup({
    label: new FormControl('', {
      validators: Validators.required
    }),
    registrationCode: new FormControl('', {
      validators: Validators.required
    })
  });


  constructor(public dialogRef: MatDialogRef<StripeAddTerminalReaderModalComponent>,
    private sessionService: SessionService,
    private stripeService: GtStripeService) {
    super();
  }

  onSubmit({ value, valid }) {
    this.isLoading = true;
    if (valid) {
      let data = {
        label: value.label,
        registration_code: value.registrationCode,
        location: this.locationId
      }
      this.stripeService.createTerminalReader(this.sessionService.getUser().stripeAccountId, data).subscribe(result => {
        if (result !== null) {
          this.dialogRef.close({status: 'success', message: 'Successfully paired new Reader'});
        }
      }, err => {
        this.isLoading = false;
        this.dialogRef.close({ status: 'failed', message: err.error });
        console.log(err);
      });
    }
  }
}
